module.exports = __webpack_public_path__ + "static/p1-7fef0f7316ecf18e72fd4dfec670f309.jpg";